import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../pages/login/auth.service';
import { AdminPermissionType } from '../models/admin-permission.type';

@Injectable({
  providedIn: 'root',
})
export class AdminPermissionGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const requiredPermission = route.data?.['requiredPermission'] as AdminPermissionType;
    if (!requiredPermission) {
      return true;
    }

    const hasPermission = await this.authService.hasAdminPermission(requiredPermission);
    if (!hasPermission) {
      this.router.navigate(['/dashboard']);
      return false;
    }

    return true;
  }
}
